import { Loader, LogOut, Settings, Trash } from 'react-feather';
import './user.css';
import { useState } from 'react';
import { deleteUser, signOut } from 'firebase/auth';
import toast from 'react-hot-toast';

function User({auth}) {
  const [isDeleting,setIsDeleting]=useState(false);
  const [isLogingOut,setIsLogingOut]=useState(false);
const manage = (e)=>{
  e.preventDefault();
  e.stopPropagation();
  return false;
}
const deleteAccount = (e)=>{
  e.preventDefault();
  e.stopPropagation();

  const sure = window.confirm('Are you sure you want to delete your account?');
  if(sure){
    setIsDeleting(true);
const user = auth.currentUser;

deleteUser(user).then(() => {
  
}).catch((error) => {
  toast.error('An unknown error occurred.');
});
  }
  return false;
}
  return (
    <form>
      <button className='delete' onClick={deleteAccount}><Trash/> {isDeleting?<Loader className='loading'/>:'Delete account'}</button>
      {1==0?<button className='manage' onClick={manage}><Settings/> Manage subscription</button>:<></>}
      <button className='logout' onClick={(e)=>{
        setIsLogingOut(true);
  e.preventDefault();
  e.stopPropagation();
  auth?.signOut().then(function() {
}, function(error) {
  console.error('Sign Out Error', error);
});return false;}}><LogOut/> {isLogingOut?<Loader className='loading'/>:'Logout'}</button>
    </form>

  );
}

export default User;